

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';
import { EnumCustomerAddressTypes } from './../enums';
export class CustomerAddress extends BaseEntity
{   
    public CustomerID: number; 
    public AddressName: string; 
    public AddressDisplayName: string; 
    public City: string; 
    public Street: string; 
    public Country: string; 
    public CountryName: string; 
    public State: string; 
    public StateName: string; 
    public ZipCode: string; 
    public IsDefaultShipment: boolean; 
    public IsDefaultBilling: boolean; 
    public Type: EnumCustomerAddressTypes; 
    public FullAddress: string; 
	
}



